import { createSelector } from 'reselect';

const institutionAutoCompleteStateSelector = state => state.InstitutionAutoComplete;

export const errorsSelector = createSelector(
  institutionAutoCompleteStateSelector,
  ({ errors }) => errors,
);

export const isLoadingSelector = createSelector(
  institutionAutoCompleteStateSelector,
  ({ isLoading }) => isLoading,
);

export const institutionsSelector = createSelector(
  institutionAutoCompleteStateSelector,
  ({ institutions }) => institutions,
);

export const querySelectorTerm = createSelector(
  institutionAutoCompleteStateSelector,
  ({ termQuery }) => termQuery,
);
